import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../util/router';
import Collapsible from "react-collapsible";
import DocumentationLink from './DocumentationLink';

import styles from './DocumentationSidebar.module.css';
import { useUser } from '../../util/user';

export default function DocumentationSidebar({ navConf, innerRef, loadedMarkdowns }) {
	const router = useRouter();
	const user = useUser();
	const [ activeItem, setActiveItem ] = useState(null);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const allHeadings = useMemo(() => innerRef.current ? Array.from(innerRef.current.querySelectorAll('.markdown-wrapper')).map(wrapper => Array.from(wrapper.querySelectorAll('h1,h2,h3,h4,h5,h6'))).flat() : [], [ innerRef, loadedMarkdowns ]);
	const navConfItemHeadingIds = useMemo(() => {
		const headingIds = [];
		const getHeadings = headingItems => {
			for(let headingItem of headingItems) {
				if(headingItem.headingId) {
					headingIds.push(headingItem.headingId);
				}
				if(headingItem.children instanceof Array) {
					getHeadings(headingItem.children);
				}
			}
		}
		getHeadings(navConf.navItems)
		return headingIds;
	}, [navConf.navItems]);
	
	const setActiveItemOnScroll = useCallback(() => {
		let mostTopHeading;
		for(let heading of allHeadings) {
			const headingPosition = heading.getBoundingClientRect();
			if(headingPosition.top >= 0 && headingPosition.top <= 100 && navConfItemHeadingIds.includes(heading.id)) {
				setActiveItem(heading.id);
				break;
			}
		}
		if(mostTopHeading) {
		}
	}, [allHeadings, navConfItemHeadingIds]);

	const setActiveItemOnHashChange = useCallback(() => {
		const hash = router.location.hash;
		if(!hash) { return }
		let elmId = hash.match(/#[a-zA-Z0-9_\-:.]+/)?.[0];
		if(!elmId) { return }
		elmId = elmId.replace(/^#/,'');
		if(allHeadings.map(heading => heading.id).includes(elmId)) {
			setActiveItem(elmId);
		}
	}, [router.location.hash, allHeadings]);

	const defaultOpenedItems = useMemo(() => {
		const defaultOpenedItems = {};
		const rootLevels = navConf.navItems.filter(item => item.children).map(item => item.headingId);
		const hash = router.location.hash || "";
		let elmId = hash.match(/#([a-zA-Z0-9_\-:.]+)/)?.[1];
		if(elmId) {
			const findElm = (items, parents=[]) => {
				for(let item of items) {
					if(item.headingId === elmId) {
						return parents;
					}
					if(item.children instanceof Array) {
						const _parents = findElm(item.children, [...parents, item.headingId]);
						if(_parents) {
							return _parents;
						}
					}
				}
			}
			const parentHeadingIds = findElm(navConf.navItems) || [];
			[...new Set([...rootLevels, ...parentHeadingIds])].forEach(headingId => { defaultOpenedItems[headingId] = true });
		} else {
			rootLevels.forEach(headingId => { defaultOpenedItems[headingId] = true });
		}
		return defaultOpenedItems;
	}, [navConf, router.location.hash]);
	const [ openedItems, setOpenedItems ] = useState(defaultOpenedItems);
	const renderNavBar = useCallback((navItems) => {
		// filter out items by hidden roles
		navItems = navItems.filter(item => !item.hiddenRoles || item.hiddenRoles.every(hiddenRole => !user.roles.includes(hiddenRole)));
		// filter items by visible roles
		navItems = navItems.filter(item => !item.visibleRoles || item.visibleRoles.some(visibleRole => user.roles.includes(visibleRole)));
		// render nav items
		return navItems.map(item => {
			if(item.children) {
				return <li>
				<Collapsible
					trigger={<span className={`${styles.collapsibleTrigger} ${activeItem === item.headingId ? 'active' : ''}`}><span className={openedItems[item.headingId] ? "glyphicon glyphicon-menu-down" : "glyphicon glyphicon-menu-up"} aria-hidden="true"></span><DocumentationLink hash={`#${item.headingId}`}>{item.text}</DocumentationLink></span>}
					transitionTime="200"
					easing="ease-in"
					onOpening={() => setOpenedItems({ ...openedItems, [item.headingId]: true })}
					open={!!openedItems[item.headingId]}
					onTriggerClosing={() => setOpenedItems({ ...openedItems, [item.headingId]: false })}
				>
					<ul className="nav nav-list">
						{renderNavBar(item.children)}
					</ul>
				</Collapsible>
			</li>
			} else {
				return <li className={activeItem === item.headingId ? 'active' : ''}><DocumentationLink hash={`#${item.headingId}`}>{item.text}</DocumentationLink></li>
			}
	});
	}, [user, activeItem, openedItems]);

	useEffect(() => {
		setActiveItemOnScroll();
		window.addEventListener("scroll", setActiveItemOnScroll);
		return () => window.removeEventListener("scroll", setActiveItemOnScroll);
	}, [ setActiveItemOnScroll ]);

	useEffect(() => {
		const timer = setTimeout(setActiveItemOnHashChange, 300);
		return () => clearTimeout(timer);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ router, setActiveItemOnHashChange ]);

	return (
		<div className={`sidebar-nav ${styles.sidebarNav}`}>
			{/* <ul className={`nav nav-list ${styles.navList}`}>
				{navConf.navItems.map(item => <li key={item.headingId} style={{ backgroundColor: activeItem === item.headingId ? 'white' : 'transparent' }}><DocumentationLink hash={`#${item.headingId}`}>{item.text}</DocumentationLink></li>)}
			</ul> */}
			<ul className="nav nav-list">
				{renderNavBar(navConf.navItems)}
			</ul>
	</div>
	)
}